import config from 'config'

const detectLanguage = () => {
	let lang = String(navigator.language || navigator.userLanguage).split('-')[0]
	const supported = ['en', 'es']

	if (!supported.includes(lang)) {
		lang = supported[0]
	}

	return lang
}

const ssoRedirect = service => {
	let url = ''

	if (service === 'google') {
		url = config.ct+'actions/user/webGoogleLogin.php?http_subtype=html'
	} else {
		url = config.ct+'actions/user/webOffice365Login.php?http_subtype=html'
	}

	return url + '&' + location.search.substr(1)
}

export {
	detectLanguage,
	ssoRedirect,
}
